export function initializeAccountMenu(root = document) {
  const shell = root.querySelector("[data-account-menu-shell]");
  const trigger = shell?.querySelector("[data-account-menu-trigger]");
  const menu = shell?.querySelector("[data-account-menu]");
  if (!(shell instanceof HTMLElement) || !(trigger instanceof HTMLButtonElement) ||
      !(menu instanceof HTMLElement)) return null;

  const items = () => [...menu.querySelectorAll("[data-account-menu-item]")]
    .filter(item => !item.hidden && !item.hasAttribute("disabled"));

  const position = () => {
    menu.style.removeProperty("left");
    menu.style.removeProperty("top");
    menu.style.removeProperty("max-height");
    const inset = 8;
    const triggerRect = trigger.getBoundingClientRect();
    const width = menu.offsetWidth;
    const height = menu.offsetHeight;
    const left = Math.min(
      Math.max(inset, triggerRect.left),
      Math.max(inset, window.innerWidth - width - inset)
    );
    const top = Math.min(
      triggerRect.bottom + 5,
      Math.max(inset, window.innerHeight - height - inset)
    );
    menu.style.left = `${Math.round(left)}px`;
    menu.style.top = `${Math.round(top)}px`;
    menu.style.maxHeight = `${Math.max(120, window.innerHeight - top - inset)}px`;
  };

  const close = ({ restoreFocus = false } = {}) => {
    if (menu.hidden) return;
    menu.hidden = true;
    trigger.setAttribute("aria-expanded", "false");
    if (restoreFocus) trigger.focus();
  };

  const open = ({ focus = "first" } = {}) => {
    if (!menu.hidden) return;
    menu.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    position();
    const menuItems = items();
    (focus === "last" ? menuItems.at(-1) : menuItems[0])?.focus();
  };

  trigger.addEventListener("click", () => {
    if (menu.hidden) open();
    else close({ restoreFocus: true });
  });
  trigger.addEventListener("keydown", event => {
    if (event.key === "ArrowDown" || event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      open();
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      open({ focus: "last" });
    } else if (event.key === "Escape") {
      event.preventDefault();
      close({ restoreFocus: true });
    }
  });
  menu.addEventListener("keydown", event => {
    const menuItems = items();
    const index = menuItems.indexOf(document.activeElement);
    if (event.key === "Escape") {
      event.preventDefault();
      close({ restoreFocus: true });
      return;
    }
    if (event.key === "Tab") {
      close();
      return;
    }
    const target = event.key === "Home" ? 0
      : event.key === "End" ? menuItems.length - 1
      : event.key === "ArrowDown" ? (index + 1 + menuItems.length) % menuItems.length
      : event.key === "ArrowUp" ? (index - 1 + menuItems.length) % menuItems.length
      : null;
    if (target !== null && menuItems.length > 0) {
      event.preventDefault();
      menuItems[target]?.focus();
    }
  });
  menu.querySelector("[data-account-menu-return]")?.addEventListener("click", event => {
    event.preventDefault();
    close({ restoreFocus: true });
  });
  document.addEventListener("pointerdown", event => {
    if (!menu.hidden && !shell.contains(event.target)) close();
  });
  window.addEventListener("resize", () => {
    if (!menu.hidden) position();
  });
  return Object.freeze({ open, close, get isOpen() { return !menu.hidden; } });
}
